import * as React from 'react';

/**
 * @typedef {import('../../App.d.ts').DefaultReactWithChildrenProps} DefaultReactWithChildrenProps
 */

/**
 *
 * @param {DefaultReactWithChildrenProps} props
 * @returns {Element}
 * @constructor
 */
export default ({ children }) => {
  return <ebds-column-layout data-testid="column-layout">{children}</ebds-column-layout>;
};
